import React from 'react';
import styled from 'styled-components';
import Spinner from '@zocdoc-frontend-common/components-spinner';

export default function LoadingOverlay() {
    return <StyledSpinner size={140} />;
}

const StyledSpinner = styled(Spinner)`
    padding-left: 30px;
`;
